; (function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('artItem', artItem)

  function artItem () {
    return {
      restrict: 'E',
      scope: {
        art: '<',
        arts: '<',
        location: '@'
      },
      templateUrl: '/arts/directives/art-item/art-item-directive.html?$$REVISION$$',
      controller: 'ArtItemController'
    }
  }
})()
